export enum PageStatus {
  LOADING = 1,
  SUCCESS = 2,
  ERROR = 3,
  EDITING = 4,
  DELETING = 5,
  READY = 6,
}
